import type { FC } from 'react';
import React, { createContext, useContext } from 'react';

export interface MetaFlowProviderProviderProps {
  isMeta: boolean;
}

const MetaFlowProviderContext = createContext<boolean>(false);

export const useMetaFlowProvider = (): boolean => {
  return useContext(MetaFlowProviderContext);
};

const MetaFlowProviderProvider: FC<MetaFlowProviderProviderProps> = ({
  isMeta,
  children,
}) => {
  return (
    <MetaFlowProviderContext.Provider value={isMeta}>
      {children}
    </MetaFlowProviderContext.Provider>
  );
};

export default MetaFlowProviderProvider;
